/* gb-pdp-addons.js (Gift Basket Delivery, 16 Oct 2026): the "Make it extra special" rows on the product page
   (snippets/gb-pdp-addons.liquid).

   Each row's button is a toggle. Tapping it shows a check mark and "Added" and puts nothing in the cart. The picked extras
   go in with the basket:
   - Add to cart (the buy box button, or the sticky bar's): one /cart/add.js request with the extras and the basket, so the
     basket and its extras are added together or not at all. The basket is sent last, so the cart lists it first with the
     extras under it. Then the shopper goes to the cart, as the theme does after an add on this store.
   - Buy with Shop / More payment options: a new cart is made with the basket and the extras (Storefront API cartCreate, the
     same thing the theme's Buy it now does with the basket alone, so the shopper's own cart is not touched) and the shopper
     goes to its checkout. Buy with Shop adds payment=shop_pay, which opens Shop Pay like the button does.
   With nothing picked, none of this runs and the theme's buttons work exactly as before. The listeners sit on window in the
   capture phase, so they run before the theme's own click handler (assets/theme.js initAddToCart) and before the payment
   buttons' own handlers. */
(function () {
  if (window.gbPdpAddons) return;
  window.gbPdpAddons = true;

  var STOREFRONT_API = '/api/2026-07/graphql.json';
  var busy = false;

  function root() { return document.querySelector('[data-gb-addons]'); }
  function shopRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  // variant ids of the picked extras, in list order
  function picks(r) {
    if (!r) return [];
    var out = [];
    r.querySelectorAll('[data-gb-addon]').forEach(function (row) {
      var b = row.querySelector('[data-gb-addon-toggle]');
      var id = row.getAttribute('data-variant-id');
      if (b && id && b.getAttribute('aria-pressed') === 'true') out.push(id);
    });
    return out;
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // row highlight and the "2 extras (+$27.05) will be added with your basket." line
  function render(r) {
    if (!r) return;
    var n = 0, total = 0;
    r.querySelectorAll('[data-gb-addon]').forEach(function (row) {
      var b = row.querySelector('[data-gb-addon-toggle]');
      var on = !!b && b.getAttribute('aria-pressed') === 'true';
      row.classList.toggle('is-picked', on);
      if (on) { n++; total += parseInt(row.getAttribute('data-price'), 10) || 0; }
    });
    var note = r.querySelector('[data-gb-addons-note]');
    if (!note) return;
    if (!n) { note.textContent = ''; return; }
    var tpl = r.getAttribute(n === 1 ? 'data-note-one' : 'data-note-many') || '{count} extras (+{total}) will be added with your basket.';
    note.textContent = tpl.replace('{count}', String(n)).replace('{total}', money(total));
  }

  function clearMsg(r) {
    var m = r && r.querySelector('[data-gb-addons-msg]');
    if (m) m.textContent = '';
  }

  function showMsg(r, text) {
    var m = r && r.querySelector('[data-gb-addons-msg]');
    if (!m) return;
    m.textContent = text || r.getAttribute('data-error') || 'Something went wrong. Please try again.';
    var box = m.getBoundingClientRect();
    if ((box.top < 0 || box.bottom > window.innerHeight) && m.scrollIntoView) m.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function unpickAll(r) {
    if (!r) return;
    r.querySelectorAll('[data-gb-addon-toggle][aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    render(r);
  }

  function go(url) { window.location.href = url; }

  // a product form for this page's product (the buy box or the sticky bar), not a quick view of another product
  function isThisProduct(form, r) {
    if (!form || !r) return false;
    var pid = form.querySelector('input[name="product-id"]');
    return !!pid && pid.value === r.getAttribute('data-product-id');
  }

  // the basket as the form would add it: variant, quantity, line item properties (the theme also reads
  // .line-item-property__field inputs outside the form) and a selling plan if there is one
  function basketLine(form) {
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string' && v !== '') props[m[1]] = v;
    });
    document.querySelectorAll('.line-item-property__field input[name^="properties"]').forEach(function (inp) {
      var m = /^properties\[(.+)\]$/.exec(inp.name);
      if (!m || inp.type === 'file' || inp.value === '') return;
      if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) return;
      props[m[1]] = inp.value;
    });
    var sp = fd.get('selling_plan');
    return {
      id: parseInt(fd.get('id'), 10) || 0,
      quantity: parseInt(fd.get('quantity'), 10) || 1,
      properties: props,
      sellingPlan: sp ? parseInt(sp, 10) || 0 : 0
    };
  }

  /* Add to cart with extras picked */
  function addToCart(form, btn, list, r) {
    var b = basketLine(form);
    if (!b.id) return false;
    var items = list.slice().reverse().map(function (v) { return { id: parseInt(v, 10), quantity: 1 }; });
    var basket = { id: b.id, quantity: b.quantity };
    if (Object.keys(b.properties).length) basket.properties = b.properties;
    if (b.sellingPlan) basket.selling_plan = b.sellingPlan;
    items.push(basket);

    busy = true;
    clearMsg(r);
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    function fail(text) {
      busy = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      showMsg(r, text);
    }

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, j: j }; });
      })
      .then(function (x) {
        if (!x.ok) { fail(x.j && (x.j.description || x.j.message)); return; }
        // they are in the cart now: clear the picks so a trip back to this page does not add them twice
        unpickAll(r);
        go(r.getAttribute('data-cart-url') || (window.routes && window.routes.cart) || '/cart');
      })
      .catch(function () { fail(); });
    return true;
  }

  /* Buy with Shop / More payment options with extras picked */
  function buyNow(form, list, r, shopPay, payBox) {
    var b = basketLine(form);
    if (!b.id) return false;
    var gid = function (id) { return 'gid://shopify/ProductVariant/' + id; };
    var lines = list.slice().reverse().map(function (v) { return { merchandiseId: gid(v), quantity: 1 }; });
    var basket = { merchandiseId: gid(b.id), quantity: b.quantity };
    var attrs = Object.keys(b.properties).map(function (k) { return { key: k, value: String(b.properties[k]) }; });
    if (attrs.length) basket.attributes = attrs;
    if (b.sellingPlan) basket.sellingPlanId = 'gid://shopify/SellingPlan/' + b.sellingPlan;
    lines.push(basket);

    var want = {};
    lines.forEach(function (l) { want[l.merchandiseId] = (want[l.merchandiseId] || 0) + l.quantity; });

    busy = true;
    clearMsg(r);
    if (payBox) payBox.classList.add('gbp-pay-busy');

    function fail(text) {
      busy = false;
      if (payBox) payBox.classList.remove('gbp-pay-busy');
      showMsg(r, text);
    }

    // if the Storefront API cannot be reached, a cart permalink takes the same items to checkout
    function permalink() {
      var parts = list.slice().reverse().map(function (v) { return v + ':1'; });
      parts.push(b.id + ':' + b.quantity);
      go(shopRoot() + 'cart/' + parts.join(',') + (shopPay ? '?payment=shop_pay' : ''));
    }

    var country = r.getAttribute('data-country') || (window.Shopify && window.Shopify.country) || '';
    var query = 'mutation gbAddonsCheckout($lines: [CartLineInput!]!, $buyer: CartBuyerIdentityInput) {' +
      ' cartCreate(input: {lines: $lines, buyerIdentity: $buyer}) {' +
      ' cart { checkoutUrl lines(first: 50) { nodes { quantity merchandise { ... on ProductVariant { id } } } } }' +
      ' userErrors { message } warnings { message } } }';

    fetch(STOREFRONT_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: query, variables: { lines: lines, buyer: country ? { countryCode: country } : null } })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('storefront ' + res.status);
        return res.json();
      })
      .then(function (j) {
        var cc = j && j.data && j.data.cartCreate;
        if (!cc) throw new Error('no cartCreate');
        var why = (cc.userErrors && cc.userErrors[0] && cc.userErrors[0].message) ||
          (cc.warnings && cc.warnings[0] && cc.warnings[0].message) || '';
        var cart = cc.cart;
        if (!cart || !cart.checkoutUrl) { fail(why); return; }
        // every item has to be in the new cart at the quantity asked for (a sold-out extra comes back at 0 with a warning)
        var got = {};
        ((cart.lines && cart.lines.nodes) || []).forEach(function (n) {
          var id = n.merchandise && n.merchandise.id;
          if (id) got[id] = (got[id] || 0) + (n.quantity || 0);
        });
        var short = Object.keys(want).some(function (k) { return (got[k] || 0) < want[k]; });
        if (short) { fail(why); return; }
        var url = cart.checkoutUrl;
        if (shopPay) url += (url.indexOf('?') > -1 ? '&' : '?') + 'payment=shop_pay';
        go(url);
      })
      .catch(permalink);
    return true;
  }

  // toggles
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-gb-addon-toggle]');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    var r = b.closest('[data-gb-addons]');
    clearMsg(r);
    render(r);
  });

  // Add to cart: runs before the theme's handler; does nothing when no extra is picked
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-btn-addtocart]');
    if (!btn || btn.disabled) return;
    var r = root();
    var list = picks(r);
    if (!list.length) return;
    var form = btn.closest('form');
    if (!isThisProduct(form, r)) return;
    if (btn.classList.contains('is-notify-me') || btn.classList.contains('is-soldout')) return;
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (addToCart(form, btn, list, r)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Buy with Shop / More payment options (and any other wallet button Shopify shows there)
  window.addEventListener('click', function (e) {
    var r = root();
    var list = picks(r);
    if (!list.length) return;
    var path = e.composedPath ? e.composedPath() : [];
    var box = null, hit = null, prev = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1) continue;
      var tag = n.tagName.toLowerCase();
      // the button that was hit is the container's child on the path (shop-pay-wallet-button, more-payment-options-link, ...)
      if (tag === 'shopify-accelerated-checkout') hit = prev;
      if (n.classList && n.classList.contains('shopify-payment-button')) { box = n; break; }
      prev = n;
    }
    if (!box) return;
    if (!hit && e.target.closest) hit = e.target.closest('.shopify-payment-button__button, .shopify-payment-button__more-options');
    if (!hit) return; // a click between the buttons
    var form = box.closest('form');
    if (!isThisProduct(form, r)) return;
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var shopPay = hit.tagName.toLowerCase() === 'shop-pay-wallet-button';
    if (buyNow(form, list, r, shopPay, box)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // back from the cart or checkout (page restored from the back-forward cache): buttons usable again
  window.addEventListener('pageshow', function () {
    busy = false;
    document.querySelectorAll('.gbp-pay-busy').forEach(function (n) { n.classList.remove('gbp-pay-busy'); });
    document.querySelectorAll('[data-btn-addtocart][aria-busy="true"]').forEach(function (n) {
      n.classList.remove('is-loading');
      n.removeAttribute('aria-busy');
    });
    render(root());
  });
})();
